import type { LiveEvaluationInteraction } from "@/types";

export function playerPrefetchUrls(
  interaction: LiveEvaluationInteraction,
  frameIndex: number,
  siblingInteractions: LiveEvaluationInteraction[] = [],
) {
  const urls = new Set<string>();

  addNeighborUrls(urls, interaction, frameIndex);
  addFindingUrls(urls, interaction);
  siblingInteractions.forEach((sibling) => {
    addFindingUrls(urls, sibling);
    const focusIndex = firstFindingFrameIndex(sibling) ?? 0;
    addNeighborUrls(urls, sibling, focusIndex);
  });

  return [...urls];
}

export function prefetchPlayerImages(urls: string[]) {
  urls.forEach((url) => {
    const image = new Image();
    image.src = url;
  });
}

function addNeighborUrls(urls: Set<string>, interaction: LiveEvaluationInteraction, frameIndex: number) {
  const screenshots = interaction.screenshots;
  addUrl(urls, screenshots[frameIndex]?.image_url);
  addUrl(urls, screenshots[frameIndex - 1]?.image_url);
  addUrl(urls, screenshots[frameIndex + 1]?.image_url);
}

function addFindingUrls(urls: Set<string>, interaction: LiveEvaluationInteraction) {
  const findingScreenshotIds = new Set(
    interaction.findings.flatMap((finding) => (finding.screenshot_id ? [finding.screenshot_id] : [])),
  );

  interaction.screenshots.forEach((screenshot) => {
    if (findingScreenshotIds.has(screenshot.id)) {
      addUrl(urls, screenshot.image_url);
    }
  });
}

function firstFindingFrameIndex(interaction: LiveEvaluationInteraction) {
  const findingScreenshotIds = new Set(
    interaction.findings.flatMap((finding) => (finding.screenshot_id ? [finding.screenshot_id] : [])),
  );

  const index = interaction.screenshots.findIndex((screenshot) => findingScreenshotIds.has(screenshot.id));
  return index >= 0 ? index : null;
}

function addUrl(urls: Set<string>, url: string | null | undefined) {
  if (url) {
    urls.add(url);
  }
}
